import { styled as muiStyled, Paper } from '@mui/material'

export const PayoutReportsToolbar = muiStyled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  width: '100%',
  padding: theme.spacing(2),
  background: 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(249,250,251,0.98) 100%)',
  backdropFilter: 'blur(24px)',
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: '0 4px 16px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    borderRadius: 12,
  },
}))

export const PayoutReportsDateRangeBox = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  '& .MuiFormControl-root': { minWidth: 160 },
  '& .MuiInputBase-root': { borderRadius: 2 },
}))

export const BrandPayoutStyledSmartTable = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
    overflow-x: auto;
    border-radius: 12px;
    border: 1px solid ${theme.palette.divider};
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    
    table {
      width: 100%;
      table-layout: auto;
      min-width: 100%;
    }
    
    th {
      background: ${theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900]};
      color: ${theme.palette.text.secondary};
      font-weight: 600;
      font-size: 0.8125rem;
      white-space: nowrap;
      padding: 14px 16px;
      min-height: 48px;
      border-bottom: 1px solid ${theme.palette.divider};
    }
    
    td {
      align-content: center;
      word-wrap: break-word;
      overflow-wrap: break-word;
      padding: 14px 16px;
      min-height: 56px;
      vertical-align: middle;
      border-bottom: 1px solid ${theme.palette.divider};
      font-size: 0.875rem;
    }
    
    tbody tr:nth-of-type(even) {
      background: ${theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900]};
    }
    
    tbody tr:nth-of-type(odd) {
      background: ${theme.palette.background.paper};
    }
    
    tbody tr:hover {
      background: ${theme.palette.action.hover} !important;
    }
    
    .table-responsive {
      width: 100%;
      overflow-x: auto;
    }
`,
)

export const PayoutReportExportPaper = muiStyled(Paper)(({ theme }) => `
  // height: 500px!important;
`)

/** Pagination bar: label + MUI Pagination, modern and easy to navigate */
export const PayoutReportsPaginationBar = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.paper,
  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  '& .pagination-label': {
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  '& .MuiPagination-root': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  '& .MuiPagination-ul': {
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
  '& .MuiPaginationItem-root': {
    minWidth: 36,
    height: 36,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: '0.875rem',
    '&.Mui-selected': {
      fontWeight: 700,
      boxShadow: `0 2px 8px ${theme.palette.primary.main}30`,
    },
    '&.MuiPaginationItem-previousNext': {
      borderRadius: 10,
    },
  },
}))